// Translations
import {
  PROCESS_COMPLETED_DESCRIPTION,
  PROCESS_COMPLETED_TITLE,
} from '../translations/iframe.translations';
// Types
import { LoadingType } from 'components/loading/types/loading.type';

const getIframeLoaderCompletedProps = (showLoader: boolean): LoadingType =>
  showLoader
    ? {
        description: PROCESS_COMPLETED_DESCRIPTION,
        title: PROCESS_COMPLETED_TITLE,
      }
    : ({} as LoadingType);

export { getIframeLoaderCompletedProps };
